import LyFileUploadForm from './src/index.vue'

LyFileUploadForm.install = function (Vue) {
    Vue.component(LyFileUploadForm.name, LyFileUploadForm)
}

export default LyFileUploadForm



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/file-upload-form/index.js
// module id = null
// module chunks = 